import { render, staticRenderFns } from "./px-menu.vue?vue&type=template&id=e87f4954&scoped=true&"
import script from "./px-menu.vue?vue&type=script&lang=ts&"
export * from "./px-menu.vue?vue&type=script&lang=ts&"
import style0 from "./px-menu.vue?vue&type=style&index=0&id=e87f4954&lang=scss&scoped=true&"
import style1 from "./px-menu.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87f4954",
  null
  
)

export default component.exports